import { motion, useReducedMotion } from 'framer-motion';
import Button from '@/components/Button';
import { Container } from '@/components/Section';
import { useQuote } from '@/components/QuoteDialog';
import { HERO_IMAGE } from '@/data/portfolio';

export default function Hero() {
  const { openQuote } = useQuote();
  const reduce = useReducedMotion();
  const fade = (delay) => ({
    initial: reduce ? false : { opacity: 0, y: 24 },
    animate: { opacity: 1, y: 0 },
    transition: { duration: 0.8, delay, ease: [0.16, 1, 0.3, 1] },
  });

  return (
    <section id="hero" className="on-dark relative min-h-[min(100svh,56rem)] flex items-end bg-ink text-white overflow-hidden">
      <img
        src={HERO_IMAGE.src}
        alt={HERO_IMAGE.alt}
        fetchPriority="high"
        className="absolute inset-0 h-full w-full object-cover"
      />
      <div className="absolute inset-0 bg-ink/60" aria-hidden="true" />
      <div className="absolute inset-x-0 bottom-0 h-2/3 bg-gradient-to-t from-ink to-transparent" aria-hidden="true" />

      <Container className="relative w-full pt-40 pb-16 sm:pb-24">
        <motion.span {...fade(0.1)} className="eyebrow mb-6 flex items-center gap-3 text-white/80">
          <span className="h-px w-8 bg-brand" aria-hidden="true" />
          Garmond Graphic · Sarajevo · od 1994.
        </motion.span>

        <motion.h1 {...fade(0.25)} className="max-w-4xl text-5xl sm:text-7xl lg:text-8xl leading-[0.95]">
          Vaš brend.
          <br />
          Uočljiv svuda.
        </motion.h1>

        <motion.p {...fade(0.45)} className="mt-8 max-w-xl text-lg sm:text-xl leading-relaxed text-white/85">
          Štampa, brendiranje i vizuelna rješenja za firme, događaje, sportske klubove i institucije.
        </motion.p>

        <motion.div {...fade(0.6)} className="mt-10 flex flex-col sm:flex-row gap-4">
          <Button onClick={() => openQuote()} data-testid="hero-cta">
            Zatražite ponudu
          </Button>
          <Button href="#portfolio" variant="outlineLight" data-testid="hero-cta-portfolio">
            Pogledajte naše radove
          </Button>
        </motion.div>
      </Container>
    </section>
  );
}
